(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fc-complete-your-set"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var sections = document.querySelectorAll('.fc-complete-your-set');

    sections.forEach(function(section) {
      var tabs = section.querySelectorAll('.fc-complete-your-set__tab');
      var panels = section.querySelectorAll('.fc-complete-your-set__panel');

      if (tabs.length > 0) {
        tabs.forEach(function(tab) {
          tab.addEventListener('click', function() {
            var index = parseInt(this.getAttribute('data-fc-tab-index'), 10);

            tabs.forEach(function(t) {
              t.classList.remove('fc-complete-your-set__tab--active');
              t.setAttribute('aria-selected', 'false');
            });

            panels.forEach(function(p) {
              p.classList.remove('fc-complete-your-set__panel--active');
              p.setAttribute('hidden', '');
            });

            this.classList.add('fc-complete-your-set__tab--active');
            this.setAttribute('aria-selected', 'true');

            if (panels[index]) {
              panels[index].classList.add('fc-complete-your-set__panel--active');
              panels[index].removeAttribute('hidden');
            }
          });

          tab.addEventListener('keydown', function(e) {
            var currentIndex = parseInt(this.getAttribute('data-fc-tab-index'), 10);
            var newIndex;

            if (e.key === 'ArrowRight') {
              newIndex = (currentIndex + 1) % tabs.length;
            } else if (e.key === 'ArrowLeft') {
              newIndex = (currentIndex - 1 + tabs.length) % tabs.length;
            } else {
              return;
            }

            e.preventDefault();
            tabs[newIndex].click();
            tabs[newIndex].focus();
          });
        });
      }

      var atcButtons = section.querySelectorAll('.fc-complete-your-set__atc-button');

      atcButtons.forEach(function(btn) {
        btn.addEventListener('click', function() {
          var variantId = this.getAttribute('data-fc-variant-id');
          if (!variantId) return;

          btn.disabled = true;
          var textEl = btn.querySelector('.fc-complete-your-set__button-text');
          var originalText = textEl.textContent;
          textEl.textContent = '...';

          var form = document.createElement('form');
          form.method = 'post';
          form.action = '/cart/add';
          form.style.display = 'none';

          var idInput = document.createElement('input');
          idInput.type = 'hidden';
          idInput.name = 'id';
          idInput.value = variantId;
          form.appendChild(idInput);

          var qtyInput = document.createElement('input');
          qtyInput.type = 'hidden';
          qtyInput.name = 'quantity';
          qtyInput.value = '1';
          form.appendChild(qtyInput);

          var submitBtn = document.createElement('button');
          submitBtn.type = 'submit';
          form.appendChild(submitBtn);

          document.body.appendChild(form);
          submitBtn.click();
          document.body.removeChild(form);

          var slidecart = document.querySelector('#slidecarthq > .slidecarthq');
          var cleared = false;

          function clearLoading() {
            if (cleared) return;
            cleared = true;
            textEl.textContent = originalText;
            btn.disabled = false;
          }

          if (slidecart) {
            var observer = new MutationObserver(function(mutations) {
              if (slidecart.classList.contains('open') && !slidecart.classList.contains('cartEmpty')) {
                observer.disconnect();
                clearLoading();
              }
            });
            observer.observe(slidecart, { attributes: true, attributeFilter: ['class'] });
            setTimeout(function() { observer.disconnect(); clearLoading(); }, 3000);
          } else {
            setTimeout(clearLoading, 1500);
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fc-header"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var drawer = document.getElementById('fc-header-drawer');
    if (!drawer) return;

    var toggleBtn = document.querySelector('.fc-header__menu-toggle');
    var closeBtn = drawer.querySelector('.fc-header__drawer-close');
    var overlay = drawer.querySelector('.fc-header__drawer-overlay');
    var content = drawer.querySelector('.fc-header__drawer-content');
    var focusableEls;
    var firstFocusableEl;
    var lastFocusableEl;

    function openDrawer() {
      drawer.setAttribute('aria-hidden', 'false');
      toggleBtn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      focusableEls = content.querySelectorAll('a[href], button, [tabindex]:not([tabindex="-1"])');
      firstFocusableEl = focusableEls[0];
      lastFocusableEl = focusableEls[focusableEls.length - 1];
      closeBtn.focus();
    }

    function closeDrawer() {
      drawer.setAttribute('aria-hidden', 'true');
      toggleBtn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      toggleBtn.focus();
    }

    function trapFocus(e) {
      if (drawer.getAttribute('aria-hidden') !== 'false') return;
      if (e.key === 'Tab') {
        if (e.shiftKey) {
          if (document.activeElement === firstFocusableEl) {
            e.preventDefault();
            lastFocusableEl.focus();
          }
        } else {
          if (document.activeElement === lastFocusableEl) {
            e.preventDefault();
            firstFocusableEl.focus();
          }
        }
      }
      if (e.key === 'Escape') {
        closeDrawer();
      }
    }

    toggleBtn.addEventListener('click', openDrawer);
    closeBtn.addEventListener('click', closeDrawer);
    overlay.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', trapFocus);

    /* Desktop dropdown toggles */
    var dropdownBtns = document.querySelectorAll('.fc-header__nav-link--dropdown');
    dropdownBtns.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        /* Close all other dropdowns */
        dropdownBtns.forEach(function(other) {
          other.setAttribute('aria-expanded', 'false');
        });
        btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      });
    });

    /* Close desktop dropdowns on outside click */
    document.addEventListener('click', function(e) {
      if (!e.target.closest('.fc-header__nav-item--has-dropdown')) {
        dropdownBtns.forEach(function(btn) {
          btn.setAttribute('aria-expanded', 'false');
        });
      }
    });

    /* Mobile drawer accordion */
    var parentLinks = drawer.querySelectorAll('.fc-header__drawer-link--parent');
    parentLinks.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        var submenu = btn.nextElementSibling;

        if (expanded) {
          /* Collapse: set explicit height first so transition can animate from it */
          submenu.style.maxHeight = submenu.scrollHeight + 'px';
          /* Force reflow */
          submenu.offsetHeight;
          submenu.style.maxHeight = '0';
          btn.setAttribute('aria-expanded', 'false');
        } else {
          /* Expand: measure and set target height */
          btn.setAttribute('aria-expanded', 'true');
          submenu.style.maxHeight = submenu.scrollHeight + 'px';
          /* Clear inline max-height after transition so content can reflow */
          submenu.addEventListener('transitionend', function handler(e) {
            if (e.propertyName === 'max-height') {
              submenu.style.maxHeight = 'none';
              submenu.removeEventListener('transitionend', handler);
            }
          });
        }
      });
    });

    /* Search toggle */
    var searchToggle = document.querySelector('.fc-header__icon-link--search');
    var searchBar = document.getElementById('fc-header-search');
    var searchInput = searchBar ? searchBar.querySelector('.fc-header__search-input') : null;

    if (searchToggle && searchBar && searchInput) {
      /* Patch PredictiveSearch.getResultsMaxHeight to use fc-header */
      var predictiveEl = searchBar.querySelector('predictive-search');
      if (predictiveEl) {
        predictiveEl.getResultsMaxHeight = function() {
          var headerRect = document.querySelector('.fc-header__search').getBoundingClientRect();
          this.resultsMaxHeight = window.innerHeight - headerRect.bottom;
          return this.resultsMaxHeight;
        };
      }

      function openSearch() {
        searchBar.setAttribute('aria-hidden', 'false');
        searchToggle.setAttribute('aria-expanded', 'true');
        /* Wait for animation to finish before focusing */
        setTimeout(function() { searchInput.focus(); }, 300);
      }

      function closeSearch() {
        searchBar.setAttribute('aria-hidden', 'true');
        searchToggle.setAttribute('aria-expanded', 'false');
        searchInput.value = '';
        /* Close predictive search results if open */
        if (predictiveEl && predictiveEl.close) predictiveEl.close(true);
        searchToggle.focus();
      }

      searchToggle.addEventListener('click', function() {
        var isOpen = searchBar.getAttribute('aria-hidden') === 'false';
        if (isOpen) {
          closeSearch();
        } else {
          openSearch();
        }
      });

      /* Close search on Escape */
      searchBar.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') {
          e.stopPropagation();
          closeSearch();
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fc-pdp-newsletter"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var sections = document.querySelectorAll('.fc-nl');

    sections.forEach(function(section) {
      var form = section.querySelector('.fc-nl__form');
      var submitBtn = section.querySelector('[data-fc-nl-submit]');

      if (!form || !submitBtn) return;

      form.addEventListener('submit', function() {
        submitBtn.setAttribute('aria-busy', 'true');
        submitBtn.disabled = true;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fc-pdp-overrides"] && !Shopify.designMode) return;
  try {
    
/* =========================================
   FC PDP - Media Gallery Video Play/Pause
   Adds click-to-play/pause overlay after
   deferred-media loads the video element.
   ========================================= */
(function () {
  var playSvg = '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="24" height="24" aria-hidden="true">'
    + '<polygon points="10,7 18,12 10,17" fill="white"/></svg>';

  function setupOverlay(deferredEl) {
    var video = deferredEl.querySelector('video');
    if (!video) return;

    /* Build overlay */
    var overlay = document.createElement('div');
    overlay.className = 'fc-video-overlay is-paused';
    var btn = document.createElement('button');
    btn.className = 'fc-video-overlay__btn';
    btn.setAttribute('type', 'button');
    btn.setAttribute('aria-label', 'Play video');
    btn.innerHTML = playSvg;
    overlay.appendChild(btn);
    deferredEl.appendChild(overlay);

    /* Click overlay (only active when paused) to play */
    overlay.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (video.paused) {
        video.play();
      }
    });

    /* Sync overlay state and native controls with video state */
    video.addEventListener('pause', function () {
      overlay.classList.add('is-paused');
      video.controls = false;
    });
    video.addEventListener('playing', function () {
      overlay.classList.remove('is-paused');
      video.controls = true;
    });
  }

  /* Watch for deferred-media elements that get loaded */
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType === 1 && (node.tagName === 'VIDEO' || node.querySelector && node.querySelector('video'))) {
          var deferred = node.closest('deferred-media');
          if (deferred && !deferred.querySelector('.fc-video-overlay')) {
            setupOverlay(deferred);
          }
        }
      });
    });
  });

  document.querySelectorAll('deferred-media').forEach(function (el) {
    /* If already loaded */
    if (el.getAttribute('loaded') && !el.querySelector('.fc-video-overlay')) {
      setupOverlay(el);
    }
    /* Watch for future loads */
    observer.observe(el, { childList: true, subtree: true });
  });
})();

/* =========================================
   FC PDP - Desktop Grid: Reorder video to 3rd
   Uses CSS order so DOM stays intact for JS.
   ========================================= */
(function () {
  var grid = document.querySelector('.m-product-media--desktop.m-product-media--grid .m-product-media--list');
  if (!grid) return;

  var items = grid.querySelectorAll('.m-product-media--item');
  var imageCount = 0;

  items.forEach(function (item) {
    var type = item.dataset.mediaType;
    if (type === 'video' || type === 'external_video') {
      /* Video always after the first 2 images */
      item.style.order = '1';
    } else {
      imageCount++;
      if (imageCount <= 2) {
        item.style.order = '0';
      } else {
        item.style.order = '2';
      }
    }
  });
})();


/* =========================================
   FC PDP - Bekijk het in actie
   Swiper slider + Video hover play/pause
   ========================================= */
(function () {
  var sliderEl = document.querySelector('[data-fc-action-slider]');
  if (!sliderEl) return;

  /* --- Init Swiper --- */
  function initSlider() {
    if (typeof MinimogLibs === 'undefined' || !MinimogLibs.Swiper) return;
    new MinimogLibs.Swiper(sliderEl, {
      slidesPerView: 'auto',
      spaceBetween: 8,
      freeMode: true,
      watchOverflow: true
    });
  }

  if (typeof MinimogLibs !== 'undefined' && MinimogLibs.Swiper) {
    initSlider();
  } else {
    document.addEventListener('DOMContentLoaded', initSlider);
  }

  /* --- Video play/pause --- */
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReducedMotion) return;

  var items = sliderEl.querySelectorAll('[data-fc-video]');
  if (!items.length) return;

  function pauseAll(except) {
    items.forEach(function (item) {
      if (item !== except && item.classList.contains('is-playing')) {
        item.classList.remove('is-playing');
        item.classList.remove('is-unmuted');
        var v = item.querySelector('video');
        if (v) {
          v.muted = true;
          v.pause();
          v.currentTime = 0;
        }
      }
    });
  }

  function playItem(item) {
    var video = item.querySelector('video');
    if (!video) return;
    pauseAll(item);

    /* On first play the video has preload="none" so the browser
       needs to fetch data before it can render a frame.
       We listen for the 'playing' event to add is-playing only
       once the video is actually rendering — this prevents the
       flicker where the poster hides but the video frame isn't
       ready yet. On subsequent plays the event fires instantly. */
    if (!video.dataset.fcReady) {
      video.preload = 'auto';
      var onPlaying = function () {
        video.removeEventListener('playing', onPlaying);
        video.dataset.fcReady = '1';
        item.classList.add('is-playing');
      };
      video.addEventListener('playing', onPlaying);
      video.play().catch(function () {
        video.removeEventListener('playing', onPlaying);
      });
    } else {
      item.classList.add('is-playing');
      video.play().catch(function () {
        item.classList.remove('is-playing');
      });
    }
  }

  function pauseItem(item) {
    var video = item.querySelector('video');
    if (!video) return;
    item.classList.remove('is-playing');
    item.classList.remove('is-unmuted');
    video.muted = true;
    video.pause();
    video.currentTime = 0;
  }

  var isTouchDevice = window.matchMedia('(hover: none)').matches;

  items.forEach(function (item) {
    var video = item.querySelector('video');

    if (!isTouchDevice) {
      item.addEventListener('mouseenter', function () {
        playItem(item);
      });
      item.addEventListener('mouseleave', function () {
        pauseItem(item);
      });
    }

    var playBtn = item.querySelector('.fc-action-videos__play-btn');
    if (playBtn) {
      playBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        if (item.classList.contains('is-playing')) {
          pauseItem(item);
        } else {
          playItem(item);
        }
      });
    }

    /* Mute / unmute button */
    var muteBtn = item.querySelector('.fc-action-videos__mute-btn');
    if (muteBtn && video) {
      muteBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        if (video.muted) {
          video.muted = false;
          item.classList.add('is-unmuted');
          muteBtn.setAttribute('aria-label', 'Mute video');
        } else {
          video.muted = true;
          item.classList.remove('is-unmuted');
          muteBtn.setAttribute('aria-label', 'Unmute video');
        }
      });
    }

    /* Listen for native pause event to restore the play button UI */
    if (video) {
      video.addEventListener('pause', function () {
        if (item.classList.contains('is-playing')) {
          item.classList.remove('is-playing');
          item.classList.remove('is-unmuted');
          video.muted = true;
        }
      });
    }
  });
})();

/* ------------------------------------------------------------------
   Benefits List — Replace circle-check with badge-check inside shadow DOM
   (section-store--benefits-list-block uses open shadow root)
   ------------------------------------------------------------------ */
(function () {
  'use strict';

  var BADGE_CHECK_SVG = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none">' +
    '<path d="M10.49 2.23c.86-.74 2.15-.74 3.01 0l1.42 1.23a2 2 0 001.18.47l1.87.1c1.13.06 2.01.94 2.07 2.07l.1 1.87a2 2 0 00.47 1.18l1.23 1.42c.74.86.74 2.15 0 3.01l-1.23 1.42a2 2 0 00-.47 1.18l-.1 1.87c-.06 1.13-.94 2.01-2.07 2.07l-1.87.1a2 2 0 00-1.18.47l-1.42 1.23c-.86.74-2.15.74-3.01 0l-1.42-1.23a2 2 0 00-1.18-.47l-1.87-.1a2.07 2.07 0 01-2.07-2.07l-.1-1.87a2 2 0 00-.47-1.18L2.15 13.5a2.1 2.1 0 010-3.01l1.23-1.42a2 2 0 00.47-1.18l.1-1.87c.06-1.13.94-2.01 2.07-2.07l1.87-.1a2 2 0 001.18-.47L10.49 2.23z" fill="#01287e"/>' +
    '<path d="M9 12l2 2 4-4" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg>';

  function replaceBenefitsIcons() {
    var blocks = document.querySelectorAll('section-store--benefits-list-block');
    blocks.forEach(function (block) {
      var root = block.shadowRoot;
      if (!root) return;

      var list = root.querySelector('.list');
      if (list) {
        list.style.lineHeight = 'normal';
        var listChildren = list.querySelectorAll('*');
        listChildren.forEach(function (child) {
          child.style.lineHeight = 'normal';
        });
      }

      var texts = root.querySelectorAll('.text *');
      texts.forEach(function (el) {
        el.style.fontWeight = '700';
        el.style.fontFamily = 'Lato, sans-serif';
      });

      var icons = root.querySelectorAll('.item .icon');
      var isMobile = window.innerWidth < 768;
      icons.forEach(function (icon) {
        icon.style.marginTop = isMobile ? '2.5px' : '4px';
        icon.style.marginBottom = isMobile ? '2.5px' : '4px';
        var svg = icon.querySelector('svg');
        if (svg) {
          svg.outerHTML = BADGE_CHECK_SVG;
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      /* Small delay to ensure shadow DOM is rendered */
      setTimeout(replaceBenefitsIcons, 100);
    });
  } else {
    setTimeout(replaceBenefitsIcons, 100);
  }
})();

/* ------------------------------------------------------------------
   Shipping Info — Inject Figma-matching styles into shadow DOM
   (section-store--shipping-info-block uses open shadow root)
   Desktop: 14px News Cycle Bold, 6px gap, justify-between
   Mobile:  12px
   ------------------------------------------------------------------ */
(function () {
  'use strict';

  var SHIPPING_STYLES = '' +
    '<style>' +
    ':host { display: block; }' +
    'section-store--shipping-info-block > div:not([style*="display: none"]):not(.loading-section-store--shipping-info-block),' +
    '.shipping-info-wrapper,' +
    ':host > div:last-of-type {' +
    '  display: flex !important;' +
    '  align-items: center !important;' +
    '  justify-content: space-between !important;' +
    '  background: #d6edf9 !important;' +
    '  border-radius: 32px !important;' +
    '  padding: 8px 12px !important;' +
    '  font-family: Lato, sans-serif !important;' +
    '  font-weight: 700 !important;' +
    '  font-size: 12px !important;' +
    '  color: #01287e !important;' +
    '  gap: 0 !important;' +
    '  border: none !important;' +
    '}' +
    '.shipping-estimate {' +
    '  display: flex !important;' +
    '  align-items: center !important;' +
    '  gap: 6px !important;' +
    '  flex: 1 0 0 !important;' +
    '  font-family: Lato, sans-serif !important;' +
    '  font-weight: 700 !important;' +
    '  font-size: 12px !important;' +
    '  color: #01287e !important;' +
    '  min-height: 20px !important;' +
    '}' +
    '.shipping-type {' +
    '  font-family: Lato, sans-serif !important;' +
    '  font-weight: 700 !important;' +
    '  font-size: 12px !important;' +
    '  color: #01287e !important;' +
    '  white-space: nowrap !important;' +
    '}' +
    '.shipping-type strong {' +
    '  font-weight: 700 !important;' +
    '}' +
    '.ships-by, .shipping-date {' +
    '  font-family: Lato, sans-serif !important;' +
    '  font-weight: 700 !important;' +
    '  font-size: 12px !important;' +
    '  color: #01287e !important;' +
    '}' +
    '.indicator {' +
    '  color: #01287e !important;' +
    '  display: flex !important;' +
    '  align-items: center !important;' +
    '  flex-shrink: 0 !important;' +
    '}' +
    '.indicator svg {' +
    '  width: 14px !important;' +
    '  height: auto !important;' +
    '}' +
    '.indicator img {' +
    '  width: 14px !important;' +
    '  height: auto !important;' +
    '  object-fit: contain !important;' +
    '}' +
    '@media (min-width: 768px) {' +
    '  section-store--shipping-info-block > div:not([style*="display: none"]):not(.loading-section-store--shipping-info-block),' +
    '  .shipping-info-wrapper,' +
    '  :host > div:last-of-type {' +
    '    font-size: 14px !important;' +
    '  }' +
    '.shipping-estimate {' +
    '  min-height: 23px !important;' +
    '}' +
    '  .shipping-estimate,' +
    '  .shipping-type,' +
    '  .ships-by,' +
    '  .shipping-date {' +
    '    font-size: 14px !important;' +
    '  }' +
    '}' +
    '</style>';

  function injectShippingStyles() {
    var blocks = document.querySelectorAll('section-store--shipping-info-block');
    blocks.forEach(function (block) {
      var root = block.shadowRoot;
      if (!root) return;
      /* Avoid double injection */
      if (root.querySelector('[data-fc-shipping-styles]')) return;
      var wrapper = document.createElement('div');
      wrapper.setAttribute('data-fc-shipping-styles', '');
      wrapper.innerHTML = SHIPPING_STYLES;
      root.prepend(wrapper.firstChild);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(injectShippingStyles, 150);
    });
  } else {
    setTimeout(injectShippingStyles, 150);
  }
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fc-pdp-section-2"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var sections = document.querySelectorAll('.fc-pdp-s2');

    sections.forEach(function(section) {
      var tabs = section.querySelectorAll('.fc-pdp-s2__tab');
      var panels = section.querySelectorAll('.fc-pdp-s2__panel');

      if (tabs.length > 0) {
        tabs.forEach(function(tab) {
          tab.addEventListener('click', function() {
            var index = parseInt(this.getAttribute('data-fc-tab-index'), 10);

            tabs.forEach(function(t) {
              t.classList.remove('fc-pdp-s2__tab--active');
              t.setAttribute('aria-selected', 'false');
            });

            panels.forEach(function(p) {
              p.classList.remove('fc-pdp-s2__panel--active');
              p.setAttribute('hidden', '');
            });

            this.classList.add('fc-pdp-s2__tab--active');
            this.setAttribute('aria-selected', 'true');

            if (panels[index]) {
              panels[index].classList.add('fc-pdp-s2__panel--active');
              panels[index].removeAttribute('hidden');
            }
          });

          tab.addEventListener('keydown', function(e) {
            var currentIndex = parseInt(this.getAttribute('data-fc-tab-index'), 10);
            var newIndex;

            if (e.key === 'ArrowRight') {
              newIndex = (currentIndex + 1) % tabs.length;
            } else if (e.key === 'ArrowLeft') {
              newIndex = (currentIndex - 1 + tabs.length) % tabs.length;
            } else {
              return;
            }

            e.preventDefault();
            tabs[newIndex].click();
            tabs[newIndex].focus();
          });
        });
      }

      var atcButtons = section.querySelectorAll('.fc-pdp-s2__atc-button');

      atcButtons.forEach(function(btn) {
        btn.addEventListener('click', function() {
          var variantId = this.getAttribute('data-fc-variant-id');
          if (!variantId) return;

          btn.disabled = true;
          var textEl = btn.querySelector('.fc-pdp-s2__button-text');
          var originalText = textEl.textContent;
          textEl.textContent = '...';

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
          })
          .then(function(response) {
            if (!response.ok) throw new Error('Add to cart failed');
            return response.json();
          })
          .then(function() {
            textEl.textContent = originalText;
            btn.disabled = false;
            document.dispatchEvent(new CustomEvent('cart:updated'));

            var cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer && typeof cartDrawer.open === 'function') {
              cartDrawer.open();
            } else {
              window.location.href = '/cart';
            }
          })
          .catch(function() {
            textEl.textContent = originalText;
            btn.disabled = false;
          });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fc-pdp-section-5"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var sections = document.querySelectorAll('.fc-pdp-s5');

    sections.forEach(function(section) {
      var triggers = section.querySelectorAll('.fc-pdp-s5__trigger');

      triggers.forEach(function(trigger) {
        trigger.addEventListener('click', function() {
          var expanded = this.getAttribute('aria-expanded') === 'true';
          var answerId = this.getAttribute('aria-controls');
          var answerWrapper = document.getElementById(answerId);

          if (!answerWrapper) return;

          if (expanded) {
            this.setAttribute('aria-expanded', 'false');
            answerWrapper.classList.remove('fc-pdp-s5__answer-wrapper--open');
          } else {
            this.setAttribute('aria-expanded', 'true');
            answerWrapper.classList.add('fc-pdp-s5__answer-wrapper--open');
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fc-pdp-section-6"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var STORAGE_KEY = 'fc-recently-viewed';
    var MAX_STORED = 20;
    var MOBILE_BP = 768;
    var instances = {};

    function getRecentlyViewed() {
      try {
        var data = localStorage.getItem(STORAGE_KEY);
        return data ? JSON.parse(data) : [];
      } catch (e) {
        return [];
      }
    }

    function saveCurrentProduct() {
      var productMeta = document.querySelector('[data-product-handle]');
      if (!productMeta) return;

      var handle = productMeta.getAttribute('data-product-handle');
      if (!handle) return;

      var viewed = getRecentlyViewed();
      console.log(viewed)
      viewed = viewed.filter(function(h) { return h !== handle; });
      viewed.unshift(handle);
      if (viewed.length > MAX_STORED) {
        viewed = viewed.slice(0, MAX_STORED);
      }

      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(viewed));
      } catch (e) { /* storage full — silently fail */ }
    }

    function formatMoney(cents) {
      var amount = parseFloat(cents).toFixed(2).replace('.', ',');
      return '\u20AC' + amount;
    }

    function escapeHtml(str) {
      var div = document.createElement('div');
      div.appendChild(document.createTextNode(str));
      return div.innerHTML;
    }

    function buildCard(product, buttonLabel) {
      var image = product.images && product.images[0] ? product.images[0] : null;
      var imageSrc = image.src;
      var imageAlt = product.title || '';
      var url = '/products/' + product.handle;
      
      var variant = null;

      if (product.variants && product.variants.length > 0) {
        for (var i = 0; i < product.variants.length; i++) {
          console.log(product.variants[i].available)
          if (product.variants[i].price > 0) {
            variant = product.variants[i];
            break;
          }
        }
      }
      var price = variant.price;
      console.log(price)
      var comparePrice = variant.compare_at_price;
      var cardHtml = '<div class="fc-pdp-s6__card swiper-slide">';

      cardHtml += '<a href="' + url + '" class="fc-pdp-s6__image-link" aria-label="' + escapeHtml(product.title) + '">';
      if (imageSrc) {
        cardHtml += '<img class="fc-pdp-s6__image image-scale-up" src="' + imageSrc + '" alt="' + escapeHtml(imageAlt) + '" loading="lazy" width="432" height="432">';
      } else {
        cardHtml += '<div class="fc-pdp-s6__image-placeholder"></div>';
      }
      cardHtml += '</a>';

      cardHtml += '<div class="fc-pdp-s6__info">';
      cardHtml += '<div class="fc-pdp-s6__meta">';
      cardHtml += '<a href="' + url + '" class="fc-pdp-s6__title">' + escapeHtml(product.title) + '</a>';
      cardHtml += '<div class="fc-pdp-s6__price">';
      if (comparePrice && comparePrice > price) {
        cardHtml += '<span class="fc-pdp-s6__price-from">Van </span>';
      }
      cardHtml += '<span>' + formatMoney(price) + '</span>';
      cardHtml += '</div>';
      cardHtml += '</div>';

      if (variant) {
        cardHtml += '<form method="post" action="/cart/add" class="fc-pdp-s6__form">';
        cardHtml += '<input type="hidden" name="id" value="' + variant.id + '">';
        cardHtml += '<input type="hidden" name="quantity" value="1">';
        cardHtml += '<button type="submit" class="fc-pdp-s6__button">' + escapeHtml(buttonLabel) + '</button>';
        cardHtml += '</form>';
      } else {
        cardHtml += '<button type="button" class="fc-pdp-s6__button fc-pdp-s6__button--disabled" disabled>Uitverkocht</button>';
      }

      cardHtml += '</div>';
      cardHtml += '</div>';

      return cardHtml;
    }

    function initSwiper(container) {
      var swiperEl = container.querySelector('[data-fc-s6-swiper]');
      if (!swiperEl) return;

      var sectionId = container.getAttribute('data-section-id');

      function create() {
        if (window.innerWidth >= MOBILE_BP) {
          destroy();
          return;
        }

        if (instances[sectionId]) return;

        instances[sectionId] = new Swiper(swiperEl, {
          slidesPerView: 'auto',
          spaceBetween: 16,
          grabCursor: true,
          freeMode: {
            enabled: true,
            sticky: true
          },
          scrollbar: {
            el: swiperEl.querySelector('.swiper-scrollbar'),
            draggable: true,
            hide: false
          }
        });
      }

      function destroy() {
        if (instances[sectionId]) {
          instances[sectionId].destroy(true, true);
          instances[sectionId] = null;
        }
      }

      create();

      var resizeTimer;
      window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(create, 150);
      });
    }

    function fetchProduct(handle) {
      return fetch('/products/' + handle + '.json')
        .then(function(response) {
          if (!response.ok) return null;
          return response.json();
        })
        .then(function(data) {
          return data ? data.product : null;
        })
        .catch(function() {
          return null;
        });
    }

    function initSection(container) {
      var track = container.querySelector('[data-fc-s6-track]');
      if (!track) return;

      var maxProducts = parseInt(container.getAttribute('data-max-products'), 10) || 3;
      var buttonLabel = container.getAttribute('data-button-label') || 'Voeg toe aan winkelwagen';

      saveCurrentProduct();

      var viewed = getRecentlyViewed();

      var currentHandle = null;
      var productMeta = document.querySelector('[data-product-handle]');
      if (productMeta) {
        currentHandle = productMeta.getAttribute('data-product-handle');
      }
      viewed = viewed.filter(function(h) { return h !== currentHandle; });
      viewed = viewed.slice(0, maxProducts);

      if (viewed.length === 0) {
        var emptyMsg = container.querySelector('[data-fc-s6-empty]');
        if (emptyMsg) emptyMsg.style.display = '';
        return;
      }

      var fetches = viewed.map(fetchProduct);

      Promise.all(fetches).then(function(products) {
        var html = '';
        products.forEach(function(product) {
          console.log(product)
          if (product) {
            html += buildCard(product, buttonLabel);
          }
        });

        if (html === '') return;

        track.innerHTML = html;
        container.style.display = '';
        initSwiper(container);
      });
    }

    function initAll() {
      document.querySelectorAll('.fc-pdp-s6').forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fc-pdp-section-6v2"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var MOBILE_BP = 768;
    var instances = {};

    function formatMoney(cents) {
      var amount = parseFloat(cents);
      var currencyCode = window.Shopify && window.Shopify.currency && window.Shopify.currency.active
        ? window.Shopify.currency.active
        : 'EUR';
      try {
        return amount.toLocaleString(undefined, {
          style: 'currency',
          currency: currencyCode
        });
      } catch (e) {
        return currencyCode + ' ' + amount.toFixed(2);
      }
    }

    function escapeHtml(str) {
      var div = document.createElement('div');
      div.appendChild(document.createTextNode(str));
      return div.innerHTML;
    }

    function buildCard(product, buttonLabel) {
      var image = product.images && product.images[0] ? product.images[0] : null;
      var imageSrc = image ? image.src : '';
      var imageAlt = product.title || '';
      var url = '/products/' + product.handle;

      var variant = null;

      if (product.variants && product.variants.length > 0) {
        for (var i = 0; i < product.variants.length; i++) {
          if (product.variants[i].price > 0) {
            variant = product.variants[i];
            break;
          }
        }
      }

      var price = variant ? variant.price : product.price;
      var comparePrice = variant ? variant.compare_at_price : product.compare_at_price;

      /* Determine min / max price across all variants */
      var minPrice = price;
      var maxPrice = price;
      var hasMultipleVariants = product.variants && product.variants.length > 1;

      if (hasMultipleVariants) {
        var prices = [];
        for (var j = 0; j < product.variants.length; j++) {
          if (product.variants[j].price > 0) {
            prices.push(parseFloat(product.variants[j].price));
          }
        }
        if (prices.length > 0) {
          minPrice = Math.min.apply(null, prices);
          maxPrice = Math.max.apply(null, prices);
        }
      }

      var cardHtml = '<div class="fc-pdp-s6__card swiper-slide">';

      cardHtml += '<a href="' + url + '" class="fc-pdp-s6__image-link" aria-label="' + escapeHtml(product.title) + '">';
      if (imageSrc) {
        cardHtml += '<img class="fc-pdp-s6__image image-scale-up" src="' + imageSrc + '" alt="' + escapeHtml(imageAlt) + '" loading="lazy" width="432" height="432">';
      } else {
        cardHtml += '<div class="fc-pdp-s6__image-placeholder"></div>';
      }
      cardHtml += '</a>';

      cardHtml += '<div class="fc-pdp-s6__info">';
      cardHtml += '<div class="fc-pdp-s6__meta">';
      cardHtml += '<a href="' + url + '" class="fc-pdp-s6__title">' + escapeHtml(product.title) + '</a>';
      cardHtml += '<div class="fc-pdp-s6__price">';
      if (hasMultipleVariants && minPrice !== maxPrice) {
        cardHtml += '<span>' + formatMoney(minPrice) + ' - ' + formatMoney(maxPrice) + '</span>';
      } else if (comparePrice && comparePrice > price) {
        cardHtml += '<span class="fc-pdp-s6__price-from">Van </span>';
        cardHtml += '<span>' + formatMoney(price) + '</span>';
      } else {
        cardHtml += '<span>' + formatMoney(price) + '</span>';
      }
      cardHtml += '</div>';
      cardHtml += '</div>';

      if (variant) {
        cardHtml += '<form method="post" action="/cart/add" class="fc-pdp-s6__form">';
        cardHtml += '<input type="hidden" name="id" value="' + variant.id + '">';
        cardHtml += '<input type="hidden" name="quantity" value="1">';
        cardHtml += '<button type="submit" class="fc-pdp-s6__button">' + escapeHtml(buttonLabel) + '</button>';
        cardHtml += '</form>';
      } else {
        cardHtml += '<button type="button" class="fc-pdp-s6__button fc-pdp-s6__button--disabled" disabled>Uitverkocht</button>';
      }

      cardHtml += '</div>';
      cardHtml += '</div>';

      return cardHtml;
    }

    function initSwiper(container) {
      var swiperEl = container.querySelector('[data-fc-s6v2-swiper]');
      if (!swiperEl) return;

      var sectionId = container.getAttribute('data-section-id');

      function create() {
        if (window.innerWidth >= MOBILE_BP) {
          destroy();
          return;
        }

        if (instances[sectionId]) return;

        instances[sectionId] = new Swiper(swiperEl, {
          slidesPerView: 'auto',
          spaceBetween: 16,
          grabCursor: true,
          freeMode: {
            enabled: true,
            sticky: true
          },
          scrollbar: {
            el: swiperEl.querySelector('.swiper-scrollbar'),
            draggable: true,
            hide: false
          }
        });
      }

      function destroy() {
        if (instances[sectionId]) {
          instances[sectionId].destroy(true, true);
          instances[sectionId] = null;
        }
      }

      create();

      var resizeTimer;
      window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(create, 150);
      });
    }

    function initSection(container) {
      var track = container.querySelector('[data-fc-s6v2-track]');
      if (!track) return;

      var maxProducts = parseInt(container.getAttribute('data-max-products'), 10) || 3;
      var buttonLabel = container.getAttribute('data-button-label') || 'Voeg toe aan winkelwagen';

      var currentHandle = null;
      var productMeta = document.querySelector('[data-product-handle]');
      if (productMeta) {
        currentHandle = productMeta.getAttribute('data-product-handle');
      }

      fetch('/collections/all/products.json?sort_by=best-selling&limit=' + (maxProducts + 1))
        .then(function(response) {
          if (!response.ok) return null;
          return response.json();
        })
        .then(function(data) {
          if (!data || !data.products) return;

          var products = data.products.filter(function(p) {
            return p.handle !== currentHandle;
          }).slice(0, maxProducts);

          if (products.length === 0) {
            var emptyMsg = container.querySelector('[data-fc-s6v2-empty]');
            if (emptyMsg) emptyMsg.style.display = '';
            return;
          }

          var html = '';
          products.forEach(function(product) {
            html += buildCard(product, buttonLabel);
          });

          track.innerHTML = html;
          container.style.display = '';
          initSwiper(container);
        })
        .catch(function() {
          /* fail silently */
        });
    }

    function initAll() {
      document.querySelectorAll('[data-fc-s6v2-track]').forEach(function(track) {
        initSection(track.closest('.fc-pdp-s6'));
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.m-section-header');
      this.megamenu = document.querySelector("mega-menu");
      this.navBar = this.querySelector('.m-header__nav');
      this.headerTop = this.querySelector('.m-header__top-wrapper');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.headerMenuIcon = this.querySelector('.m-header-menu-icon');
      this.headerBounds = {};
      this.headerTop = this.querySelector('.m-header__top-wrapper');

      this.setHeaderHeight();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('m-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.headerMenuIcon.addEventListener("click", this.toggleMenuBar.bind(this));

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    toggleMenuBar() {
      if (this.headerMenuIcon.classList.contains('is-open')) {
        this.headerMenuIcon.classList.remove('is-open');
      } else {
        this.headerMenuIcon.classList.add('is-open');
      }
      if (this.navBar.classList.contains('nav-bar-hidden')) {
        this.navBar.classList.remove('nav-bar-hidden');
        this.headerTop.classList.remove('nav-bar-hidden');
      } else {
        this.navBar.classList.add('nav-bar-hidden');
        this.headerTop.classList.add('nav-bar-hidden');
        
      }
    }

    setHeaderTopHeight () {
      document.documentElement.style.setProperty('--header-height', `${this.headerTop.offsetHeight}px`);
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      document.documentElement.style.setProperty('--nav-bar-height', `${this.navBar.offsetHeight}px`);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        document.documentElement.classList.add('scrolled-past-header');
        this.setHeaderTopHeight();
        if (!this.headerMenuIcon.classList.contains('is-open')) {
          this.navBar.classList.add('nav-bar-hidden');
          this.headerTop.classList.add('nav-bar-hidden');
        }
        this.megamenu && this.megamenu.init();
        this.megamenu && this.megamenu.close();
        this.headerIsAlwaysSticky && this.megamenu && this.megamenu.setAttribute("data-toggle", "true");
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        document.documentElement.classList.remove('scrolled-past-header');
        this.navBar.classList.remove('nav-bar-hidden');
        this.headerTop.classList.remove('nav-bar-hidden');
        this.headerMenuIcon.classList.remove('is-open');
        this.setHeaderHeight();
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.megamenu && this.megamenu.removeAttribute("data-toggle");
      this.header.classList.add('m-section-header-hidden', 'm-section-header-sticky');
      document.documentElement.classList.add('m-section-header-hidden');
      this.closeLocalizationForm();
      this.closePredictiveSearch();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.megamenu && this.megamenu.setAttribute("data-toggle", "true");
      this.header.classList.add('m-section-header-sticky', 'animate');
      this.header.classList.remove('m-section-header-hidden');
      document.documentElement.classList.remove('m-section-header-hidden');
    }

    reset() {
      if (this.megamenu && this.megamenu.openDefault && this.megamenu.template === 'index') {
        this.megamenu && this.megamenu.open();
      }
      if (this.currentScrollTop === 0) {
        this.megamenu && this.megamenu.removeAttribute("data-toggle");
      }
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('m-section-header-hidden', 'm-section-header-sticky', 'animate');
    }

    closePredictiveSearch() {
      this.predictiveSearch = this.predictiveSearch || this.header.querySelector('predictive-search');
      this.predictiveSearch.close(false);
    }

    closeLocalizationForm() {
      this.localization = this.localization || this.header.querySelectorAll('localization-form');
      this.localization.forEach(localization => localization.hidePanel());
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
